<template>
  <div class="page">
    <!-- Content Section and Navigation Together -->
    <div class="content-wrapper">
      <!-- Content Section -->
      <div class="content-section">
        <div v-for="(item, index) in content.Items" :key="index" class="content-item">
          <div class="card">  
            <div class="card-body">
              <h1 class="title">{{ item.title }}</h1>
              <div v-html="formattedDescriptionNo(item.description_no_1)" class="description_no"></div> 
              <div v-html="formattedDescriptionNo(item.description_1)" class="description"></div>
              <div v-html="formattedDescriptionNo(item.description_2)" class="description"></div>
              <div class="card-header">
                <img :src="item.image" alt="Content Image" class="image" />
              </div>  
              <div v-html="formattedDescriptionNo(item.description_3)" class="description"></div>
              <div class="card-header">
                <img :src="item.image_1" alt="Content Image" class="image" />
              </div>  
              <div v-html="formattedDescriptionNo(item.description_4)" class="description"></div>
              <div class="card-header">
                <img :src="item.image_2" alt="Content Image" class="image" />
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
      <!-- Contact Section (moved to the right) -->
      <!-- <div class="contact-container">
        <h2>Contact Information</h2>
        <div class="contact-info">
          <i class="fas fa-phone"></i>
          <p>Phone: +86 19883038871</p>
        </div>
        <div class="contact-info">
          <i class="fas fa-envelope"></i>
          <p>Email: dankao.chen@nxtech.pub</p>
        </div>
      </div> -->
    </div>

</template>

<style src="@/assets/css/news.css" scoped></style>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      cn: {
        Items: [
          {
            id: 1,
            image: require("@/assets/img/News/006/market.png"),
            image_1: require("@/assets/img/News/006/users.png"),
            image_2: require("@/assets/img/News/006/TechImplement.png"),
            title: "云翰虹章与顾问徐宁宁启动联合项目-VR音乐游戏",
            description_no_1:``,
            description_1:`
            2024年6月，云翰虹章与顾问徐宁宁联合启动的VR音乐游戏项目正式启动，并被纳入2024年度李达三创新基金（Li Dak Sum Innovation Fellowship）的申报项目。徐宁宁毕业于西交利物浦大学应用信息学专业，现于宁波诺丁汉大学攻读博士，专注于人机交互领域的研究。
            `,
            description_2:`李达三创新基金由宁波诺丁汉大学设立，并由李达三孵化园监督管理，旨在促进技术成果的转化。自2019年成立以来，每年为博士后研究助理、研究人员及学术成员提供高达300万元的资助，支持创新项目，推动学术成果的产业化。云翰虹章团队、顾问徐宁宁以及李达三创新基金三方不约而同地看到了未来音乐游戏市场的巨大潜力，决定联手开展VR音乐游戏项目。`,

            description_3:`
            调研表明，目前行业内对VR技术在音乐创作和分享中的潜力关注不足。而本项目将应用虚拟现实（VR）技术，利用计算机技术构建一个融合视觉、触觉和嗅觉等多感官体验的虚拟世界，旨在实现高度沉浸的用户音乐体验。经行业调研，最终我们选择使用虚幻引擎5开发音乐创作游戏的功能原型。该原型将大幅降低音乐创作与演奏的门槛，使不同音乐素养的用户都能在其中享受优质的视听体验。
            `,
            description_4:`
            云翰虹章与徐宁宁将在此项目中开展深入合作，专注于技术原型和产品研发，探索基于用户生成内容的平台。我们相信，未来云翰虹章将推动VR技术在音乐领域的广泛应用，开辟全新的发展前景。下图为云翰虹章技术团队正在测试VR音乐游戏原型：
            `,
          },
          // Add more items as needed
        ],
      },
      en: {
        Items: [
          {
            id: 2,
            image: require("@/assets/img/News/006/market.png"),
            image_1: require("@/assets/img/News/006/users.png"),
            image_2: require("@/assets/img/News/006/TechImplement.png"),
            title: "Rosy Nebula and Consultant Ningning Xu started the Joint Project - VR Music Game",
            description_no_1:``,
            description_1:`
            In June 2024, Rosy Nebula and consultant Ningning Xu officially launched a VR music game project, which was included in the 2024 Li Dak Sum Innovation Fellowship. Ningning Xu was graduated in Applied Informatics from Xijiao Liverpool University and is now pursuing her PhD at the University of Nottingham Ningbo, focusing on human-computer interaction.
            `,
            description_2:`Established by the University of Nottingham Ningbo and supervised and managed by the Lidasan Incubator, the Lidasan Innovation Fund aims to promote the transformation of technological achievements. Since its inception in 2019, it has provided up to 3 million RMB per year for postdoctoral research assistants, researchers and academic members to support innovative projects and promote the industrialisation of academic achievements. The Rosy Nebula team, consultant Ningning Xu, and Li Da San Innovation Fund coincidentally saw the huge potential of the future music game market, and decided to join forces to carry out a VR music game project.`,

            description_3:`
            Research has shown that there is currently insufficient attention in the industry to the potential of VR technology in music creation and sharing. Instead, this project will apply Virtual Reality (VR) technology, using computer technology to build a virtual world that integrates multi-sensory experiences such as vision, touch and smell, aiming to achieve a highly immersive user music experience. After industry research, we finally chose to develop a functional prototype of a music creation game using Unreal Engine 5. The prototype will dramatically lower the threshold of music creation and performance, enabling users with different music literacy to enjoy a high-quality audio-visual experience.
            `,
            description_4:`
            Rosy Nebula's technical team will work closely with Ningning Xu on this project, focusing on technical prototyping and product development, and exploring a platform based on user-generated content. We believe that in the future, Rosy Nebula will promote the wide application of VR technology in the field of music, opening up a whole new prospect for development.
            
            The picture below shows Rosy Nebula's technical team testing the VR music game prototype:
            `,
          },
          // Add more items as needed
        ],
      },
    };
  },
  methods: {
    formattedDescription(description) {
      // Apply additional formatting if needed
      return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
    formattedDescriptionNo(description_no) {
      // Apply additional formatting if needed
      return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
  },
  mixins: [],
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      console.log("Current Language:", currentLanguage); // Debug statement
      return currentLanguage || defaultContent;
    },
  },
  watch: {
    language(newValue) {
      console.log("Language changed to:", newValue); // Debug statement
      this.$forceUpdate(); // Force the component to re-render when the language changes
    },
  },
};
</script>
